var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"tabs is-centered"},[_c('ul',_vm._l((_vm.getAllTabs),function(tab){return _c('li',[_c('a',{class:{'is-active' : tab.status },on:{"click":function($event){_vm.setActiveTab(tab)}}},[_vm._v(_vm._s(tab.name))])])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72dd439a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/User/UserSideBar.vue
// module id = null
// module chunks = 